var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Grid, MenuItem } from '@mui/material';
import InputDados from '../../../components/input_dados';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { FUNCIONALIDADES } from '../../../routes';
export var FiltrosAtendimentos = function (_a) {
    var filtros = _a.filtros, atualizarFiltros = _a.atualizarFiltros, getCombosListar = _a.getCombosListar;
    var _b = useState([]), usuariosDisponiveis = _b[0], setUsuariosDisponiveis = _b[1];
    var _c = useState([]), situacoesDisponiveis = _c[0], setSituacoesDisponiveis = _c[1];
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var acoesAdmin = getAcoesFuncionalidade(FUNCIONALIDADES.ATENDIMENTOS_ADMIN);
    var eAtendenteAdmin = !!(acoesAdmin === null || acoesAdmin === void 0 ? void 0 : acoesAdmin['VISUALIZAR']);
    useEffect(function () {
        var carregarCombos = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!getCombosListar)
                            return [2 /*return*/];
                        return [4 /*yield*/, getCombosListar()];
                    case 1:
                        res = _a.sent();
                        if (res && res.Status !== 'ERRO') {
                            setUsuariosDisponiveis(res.usuarios || []);
                            setSituacoesDisponiveis(res.situacoes || []);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        carregarCombos();
    }, [getCombosListar]);
    return (_jsxs(Grid, __assign({ container: true, spacing: 1, mt: 2, mb: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsx(InputDados, { id: 'data_inicio', label: 'Data In\u00EDcio', mask: '99/99/9999', value: filtros.dataInicio, onChange: function (e) { return atualizarFiltros({ dataInicio: e.target.value }); }, size: 'small' }) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsx(InputDados, { id: 'data_fim', label: 'Data Fim', mask: '99/99/9999', value: filtros.dataFim, onChange: function (e) { return atualizarFiltros({ dataFim: e.target.value }); }, size: 'small' }) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'Atendente', label: 'Atendente', placeholder: 'Atendente', value: filtros.atendente, onChange: function (e) { return atualizarFiltros({ atendente: e.target.value }); }, size: 'small', disabled: !eAtendenteAdmin }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: "Selecione..." })), usuariosDisponiveis === null || usuariosDisponiveis === void 0 ? void 0 : usuariosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'situacao', label: 'Situa\u00E7\u00E3o', placeholder: 'Situa\u00E7\u00E3o', value: filtros.situacao, onChange: function (e) { return atualizarFiltros({ situacao: e.target.value }); }, size: 'small' }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Selecione..." })), situacoesDisponiveis === null || situacoesDisponiveis === void 0 ? void 0 : situacoesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.nome }, { children: item.nome }), item.nome)); })] })) }))] })));
};
